// extracted by mini-css-extract-plugin
export default {"labelStyles":"progressBar_labelStyles__LQq+2"};